var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchemeInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 5H9C7.9 5 7.01 5.9 7.01 7L7 23C7 24.1 7.89 25 8.99 25H21C22.1 25 23 24.1 23 23V11L17 5ZM9 7H16L21 12V20.58L19.16 18.74C19.7935 17.7799 20.0758 16.6303 19.9592 15.4859C19.8426 14.3416 19.3342 13.2726 18.52 12.46C18.0585 11.9966 17.5099 11.629 16.9058 11.3785C16.3017 11.1279 15.654 10.9993 15 11C13.6765 11.0003 12.4071 11.5253 11.47 12.46C11.0065 12.9226 10.6387 13.472 10.3878 14.0769C10.1369 14.6817 10.0078 15.3302 10.0078 15.985C10.0078 16.6398 10.1369 17.2883 10.3878 17.8931C10.6387 18.498 11.0065 19.0474 11.47 19.51C12.2829 20.3243 13.3526 20.832 14.4975 20.9469C15.6423 21.0617 16.7916 20.7766 17.75 20.14L20.6 23H9V7ZM17.11 18.1C16.55 18.66 15.8 18.98 15 18.98C14.2 18.98 13.45 18.67 12.89 18.1C12.33 17.54 12.01 16.79 12.01 15.99C12.01 15.19 12.32 14.44 12.89 13.88C13.45 13.31 14.2 13 15 13C15.8 13 16.55 13.31 17.11 13.88C17.67 14.44 17.99 15.19 17.99 15.99C17.99 16.79 17.68 17.54 17.11 18.1Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchemeInfoIcon);
export default __webpack_public_path__ + "static/media/scheme-info-icon.1c55c6c02becc8cd35f9cc07818b2412.svg";
export { ForwardRef as ReactComponent };